export const locale = {
    lang: 'en',
    data: {
        'TOOLBAR': {
            'PERFIL': 'My Profile' ,
            'INBOX': 'Inbox',
            'LOGOUT': 'Logout',
            'ADMIN': 'signed in as:',
            'LOGIN':'Login at: ',
            'GOPROFILE':'Profile',
            'CITIES':{
                '0':'',
                '1':'Mexico City',
                '2':'San salvador',
                '3':'Hong kong',
                '4':'Singapure',
                '5':'Istanbul',
                '6':'Victoria',
                '8':'Mexico City',
                '11':'São Paulo',
                '14':'Mexico City',
                '15':'Madrid',
                'IZZI':'Mexico City',
                'MX':'Mexico City',
                '19':'Mexico City',
                '22':'Hong kong',
            },
            'LOGOUT_MODAL': {
              'TEXTO': 'Are you sure to log out?',
              'SI': 'Yes',
              'NO': 'No'
            }
        }
    }
};
